require("-!/data/jenkins/workspace/CD-PROD/feedback-ui/node_modules/extract-text-webpack-plugin/loader.js?omit=1&remove=true!style-loader!css-loader!sass-loader!/data/jenkins/workspace/CD-PROD/feedback-ui/node_modules/bootstrap-sass-loader/bootstrap-sass-styles.loader.js!/data/jenkins/workspace/CD-PROD/feedback-ui/src/theme/bootstrap.config.prod.js");
require("-!/data/jenkins/workspace/CD-PROD/feedback-ui/node_modules/bootstrap-sass-loader/bootstrap-sass-scripts.loader.js!/data/jenkins/workspace/CD-PROD/feedback-ui/src/theme/bootstrap.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-sass-loader/index.loader.js!./src/theme/bootstrap.config.prod.js
// module id = 1123
// module chunks = 0